export const strings = {
  steps: 'Steps',
  of: 'of',
}
